import apiService from './api';
import { UserDTO, PayoutDTO } from '../types';

class AdminService {
  async getAllUsers(): Promise<UserDTO[]> {
    const response = await apiService.get<UserDTO[]>('/user/admin/users');
    return response.data;
  }

  async getUserById(userId: string): Promise<UserDTO> {
    const response = await apiService.get<UserDTO>(`/user/admin/users/${userId}`);
    return response.data;
  }

  async getUserPayments(userId: string): Promise<PayoutDTO[]> {
    const response = await apiService.get<PayoutDTO[]>(`/payout/admin/${userId}/list`);
    return response.data;
  }

  async createPayment(paymentData: any): Promise<PayoutDTO[]> {
    const response = await apiService.post<PayoutDTO[]>('/payout/create', paymentData);
    return response.data;
  }

  async updateUserStatus(userId: string, isActive: boolean): Promise<void> {
    await apiService.put(`/admin/users/${userId}/status`, { isActive });
  }
}

export const adminService = new AdminService();
export default adminService;
